/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `New`
};

const fr_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `Nouveau`
};

const de_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `Neu`
};

const es_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `Nuevo`
};

const it_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `Nuovo`
};

const ar_collection_card_tag_new20 = /** @type {(inputs: {}) => string} */ () => {
	return `جديد`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_card_tag_new20 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_card_tag_new20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_card_tag_new20", locale)
	if (locale === "en") return en_collection_card_tag_new20(inputs)
	if (locale === "fr") return fr_collection_card_tag_new20(inputs)
	if (locale === "de") return de_collection_card_tag_new20(inputs)
	if (locale === "es") return es_collection_card_tag_new20(inputs)
	if (locale === "it") return it_collection_card_tag_new20(inputs)
	return ar_collection_card_tag_new20(inputs)
};
export { collection_card_tag_new20 as "COLLECTION_CARD_TAG_NEW" }